import { Link } from "react-router-dom";
import { BadgeCheck, ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { CERT_DETAILS, IMAGES } from "@/lib/data";

export default function Certifications() {
  return (
    <main className="bg-beige" data-testid="certifications-page">
      <section className="relative pt-40 pb-20 bg-forest text-beige overflow-hidden grain">
        <img src={IMAGES.warehouse} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest to-forest/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6">
          <p className="overline text-gold mb-4">Trust & Compliance</p>
          <h1 className="font-serif text-6xl md:text-7xl leading-none">Certified at every<br /><span className="italic text-gold">checkpoint.</span></h1>
          <p className="mt-6 text-beige/75 font-light max-w-xl text-lg">
            Nine internationally respected certifications back every consignment — so buyers across 42+ countries import with total confidence.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CERT_DETAILS.map((c, i) => (
            <Reveal key={c.code} delay={(i % 3) * 0.08} className="card-soft p-8 group min-h-[240px]" data-testid={`cert-${c.code.toLowerCase().replace(" ", "-")}`}>
              <div className="flex items-center justify-between mb-6">
                <span className="font-serif text-3xl text-forest">{c.code}</span>
                <div className="w-11 h-11 rounded-full bg-olive/10 flex items-center justify-center group-hover:bg-gold transition-colors duration-500">
                  <BadgeCheck className="w-5 h-5 text-olive group-hover:text-forest transition-colors duration-500" />
                </div>
              </div>
              <p className="text-sm font-medium text-gold mb-3">{c.name}</p>
              <p className="text-ink/60 text-sm leading-relaxed font-light">{c.desc}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-16 bg-forest text-beige rounded-2xl p-10 md:p-14 grain relative overflow-hidden">
          <div className="relative z-10 flex flex-col md:flex-row md:items-center justify-between gap-8">
            <div>
              <h2 className="font-serif text-3xl md:text-4xl leading-tight mb-3">Need documentation for your import market?</h2>
              <p className="text-beige/70 font-light max-w-xl">We provide Certificate of Analysis, phytosanitary certificates and full export paperwork with every shipment.</p>
            </div>
            <Link to="/contact" data-testid="cert-contact-cta"
              className="group flex items-center gap-3 bg-gold text-forest px-8 py-4 text-sm uppercase tracking-widest font-medium rounded-full hover:bg-beige transition-colors shrink-0">
              Request Documents <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
